export interface IResetPasswordLog {
  ipAddress: string;
  user_action: {
    _id: string;
    username: string;
    role: Role;
  };
  user_passive: {
    _id: string;
    username: string;
    role: Role;
  };
  timestamp: string;
}

export enum Role {
  superadmin = 'SUPERADMIN',
  admin = 'ADMIN',
  member = 'MEMBER',
  subaccount = 'SUBACCOUNT',
  subcompany = 'SUBCOMPANY',
  subagent = 'SUBAGENT',
}

export interface IReqResetPassLog {
  limit: number;
  page: number;
  username: string;
}
